import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import CommerceHero from "@/components/CommerceHero";
import CapabilityBar from "@/components/CapabilityBar";
import ProblemCompare from "@/components/ProblemCompare";
import Engines from "@/components/Engines";
import Pillars from "@/components/Pillars";
import HowItWorksStrip from "@/components/HowItWorksStrip";
import FeatureExplorer from "@/components/FeatureExplorer";
import BeforeAfter from "@/components/BeforeAfter";
import ConfigureOnce from "@/components/ConfigureOnce";
import WhiteLabel from "@/components/WhiteLabel";
import WhoFor from "@/components/WhoFor";
import WhyDMCs from "@/components/WhyDMCs";
import MultiTenant from "@/components/MultiTenant";
import GlobalMap from "@/components/GlobalMap";
import Pricing from "@/components/Pricing";
import LeadForm from "@/components/LeadForm";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import DemoMode from "@/components/DemoMode";
import LeadsAdmin from "@/pages/LeadsAdmin";
import Brochure from "@/pages/Brochure";
import Platform from "@/pages/Platform";
import HowItWorks from "@/pages/HowItWorks";

function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      const t = setTimeout(() => {
        document.querySelector(window.location.hash)?.scrollIntoView();
      }, 500);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <div className="min-h-screen bg-paper text-ink">
      <Navbar />
      <main>
        <CommerceHero />
        <CapabilityBar />
        <ProblemCompare />
        <Engines />
        <Pillars />
        <HowItWorksStrip />
        <FeatureExplorer />
        <BeforeAfter />
        <ConfigureOnce />
        <WhiteLabel />
        <WhoFor />
        <WhyDMCs />
        <MultiTenant />
        <GlobalMap />
        <Pricing />
        <LeadForm />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

function SubPage({ children }) {
  return <div className="min-h-screen bg-paper text-ink">{children}</div>;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/platform" element={<SubPage><Platform /></SubPage>} />
        <Route path="/how-it-works" element={<SubPage><HowItWorks /></SubPage>} />
        <Route path="/admin" element={<LeadsAdmin />} />
        <Route path="/brochures/:market" element={<Brochure />} />
      </Routes>
      <DemoMode />
    </BrowserRouter>
  );
}

export default App;
